import { useEffect, useState } from 'react';
export const useIsMobile = () => {
  const browserDetail = navigator.userAgent;
  const isMobile =
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(browserDetail) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(browserDetail);
  const [isPortrait, setPortrait] = useState(window.matchMedia('(orientation: portrait)').matches);

  useEffect(() => {
    window.matchMedia('(orientation: portrait)').addEventListener('change', e => {
      setPortrait(e.matches);
    });

    return () => {
      window.removeEventListener('change', () => {});
    };
  }, []);

  return { isMobile, isPortrait };
};
